/** ساخت پیلود شیفت بدون فیلدهای غیرمرتبط (بدون null برای فیلدهای مخفی) */
export function buildEmployeeShiftPayload(values, { deriveShortCode }) {
  const isStrict = values.shift_type === 'strict';
  const isFlexible = values.shift_type === 'flexible';

  const payload = {
    shift_type: values.shift_type,
    shift_name: values.shift_name,
    shift_short_code: deriveShortCode(values.shift_name, values.shift_short_code),
    color: typeof values.color === 'string' ? values.color : values.color?.toHexString?.() || '#16813D',
    office_open_days: (values.office_open_days || []).map(Number),
  };

  if (isStrict) {
    if (values.office_start_time) {
      payload.office_start_time = values.office_start_time.format('HH:mm');
    }
    if (values.office_end_time) {
      payload.office_end_time = values.office_end_time.format('HH:mm');
    }
    if (values.halfday_mark_time) {
      payload.halfday_mark_time = values.halfday_mark_time.format('HH:mm');
    }
    if (values.early_clock_in != null) {
      payload.early_clock_in = Number(values.early_clock_in);
    }
    if (values.late_mark_duration != null) {
      payload.late_mark_duration = Number(values.late_mark_duration);
    }
    if (values.clockin_in_day != null) {
      payload.clockin_in_day = Number(values.clockin_in_day);
    }
  }

  if (isFlexible) {
    if (values.total_shift_hours != null && values.total_shift_hours !== '') {
      payload.total_shift_hours = Number(values.total_shift_hours);
    }
    if (values.halfday_shift_hours != null && values.halfday_shift_hours !== '') {
      payload.halfday_shift_hours = Number(values.halfday_shift_hours);
    }
  }

  return payload;
}

export function getShiftFormFieldsToValidate(shiftType) {
  const base = ['shift_type', 'shift_name', 'shift_short_code', 'color', 'office_open_days'];
  if (shiftType === 'strict') {
    return [
      ...base,
      'office_start_time',
      'office_end_time',
      'halfday_mark_time',
      'early_clock_in',
      'late_mark_duration',
      'clockin_in_day',
    ];
  }
  if (shiftType === 'flexible') {
    return [...base, 'total_shift_hours', 'halfday_shift_hours'];
  }
  return base;
}
